<template>
    <div class="row">
        <div class="column">
            <div class="noBox"></div>
            <h1>{{$t('products.noProduct')}}</h1>
            <p v-if="$store.getters.USERPROFILE['product-administration']">{{$t('products.createProductBeforeAssign')}}</p>
            <router-link v-if="$store.getters.USERPROFILE['product-administration']" :to="{name: 'createProduct'}">
                <button>
                    <i class="fas fa-plus"></i> {{$t('button.createProduct')}}
                </button>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return { }
        }
    }
</script>

<style scoped>
    .column {
        flex-grow: 1;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding-bottom: 100px;
        padding-top:100px;
    }
    h1, p {
        padding: 12px 0px;
    }
    button {
        margin: 12px 0px;
    }
</style>